import { DataModel } from "common/models/utility-models/base-model";

export class PackageListModel extends DataModel {
  override id: '';
  title: '';
}
